import React from 'react';
import './App.css';
import Home from './views/Home/Home';
import HowItHelps from './views/HowItHelps/HowItHelps';
import Blog from './views/Blog/Blog';
import Blog2 from './views/Blog/Blog2';
import Blog3 from './views/Blog/Blog3';
import ImmunityInflammation from './views/ImmunityInflammation/ImmunityInflammation';
import HormonalHealth from './views/HormonalHealth/HormonalHealth';
import DiabetesHeartHealth from './views/DiabetesHeartHealth/DiabetesHeartHealth';
import Cancer from './views/Cancer/Cancer';
import PrivacyPolicy from './views/PrivacyPolicy/PrivacyPolicy';

// React Bootstrap related imports
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import 'bootstrap/dist/css/bootstrap.min.css';

// React Router related imports
import {
  HashRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

function App() {
  return (
    <Router basename={`${process.env.PUBLIC_URL}/`}>
      <div className="App">
        <Navbar className={'navbar'} style={{position:'fixed', top:0, width:'100%'}}>
          <Navbar.Brand href="/#/home" style={{color:'#57a99a'}}>Naturomind</Navbar.Brand>
          <Nav className="mr-auto">
            <Nav.Link href="/#/home" className={'header-link'}>Home</Nav.Link>
            <Nav.Link href='/#/how-it-helps' className={'header-link'}>How It Helps</Nav.Link>
            <Nav.Link href='/#/immunity-&-inflammation' className={'header-link'}>Immunity & Inflammation</Nav.Link>
            <Nav.Link href='/#/hormonal-health' className={'header-link'}>Hormonal Health</Nav.Link>
            <Nav.Link href='/#/diabetes-&-heart-health' className={'header-link'}>Diabetes & Heart Health</Nav.Link>
            <Nav.Link href='/#/cancer' className={'header-link'}>Cancer</Nav.Link>
            <Nav.Link href='/#/blog/1' className={'header-link'}>Blog</Nav.Link>
            <Nav.Link href='/#/privacy-policy/' className={'header-link'}>Privacy Policy</Nav.Link>
          </Nav>
        </Navbar>
        <Switch>
          <Route exact path="/home">
            <Home />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/how-it-helps">
            <HowItHelps />
          </Route>
          <Route path='/blog/1'>
            <Blog />
          </Route>
          <Route path='/blog/2'>
            <Blog2 />
          </Route>
          <Route path='/blog/3'>
            <Blog3 />
          </Route>
          <Route path='/immunity-&-inflammation'>
            <ImmunityInflammation />
          </Route>
          <Route path='/hormonal-health'>
            <HormonalHealth />
          </Route>
          <Route path='/diabetes-&-heart-health'>
            <DiabetesHeartHealth />
          </Route>
          <Route path='/cancer'>
            <Cancer />
          </Route>
          <Route path='/privacy-policy'>
            <PrivacyPolicy />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
